import { render, staticRenderFns } from "./livenessCheck.vue?vue&type=template&id=4f766aae&scoped=true"
import script from "./livenessCheck.vue?vue&type=script&lang=js"
export * from "./livenessCheck.vue?vue&type=script&lang=js"
import style0 from "./livenessCheck.vue?vue&type=style&index=0&id=4f766aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f766aae",
  null
  
)

export default component.exports